import {
  TypedBodyCellProps,
  ProjectLocationLinkDisplayComponent,
  PlaceholderTextCell,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { LinkCellFormatter } from './LinkCellFormatter';

export function createProjectLocationLinkCellFormatter<TRowData>(
  getLocationId: (rowData: TRowData) => string | null,
  getLocation: (rowData: TRowData) => string | null,
  disableTabIndex = false,
  getDisabledFromRowData?: (rowData: TRowData) => boolean,
  ): React.Factory<TypedBodyCellProps<TRowData>> {
    return function createProjectLocationCell(props: TypedBodyCellProps<TRowData>) {
        return (
          <ProjectLocationLinkDisplayComponent
          // the pathname is constructed using location, that is why location and locationId is
          // interchanged. Will need to correct it later
          location={getLocationId(props.row.data)}
          locationId={getLocation(props.row.data)}
          hiddenLocationElement={<PlaceholderTextCell placeholderText={Messages.PermissionsRequired()}/>}
          noneLocationElement={<PlaceholderTextCell placeholderText={Messages.None()} />}
          linkComponent={
            ({pathname}) =>
            <LinkCellFormatter
              text={getLocation(props.row.data)}
              pathname={pathname}
              noPadding={false}
              disableTabIndex={disableTabIndex}
              disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
            />
          }/>
          );
        };
      }
